export { CarouselModule } from './carousel.module';
